import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderAddRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderAddRight"><Path d="M12.5 19.5H2.5V3.5H10L12 6.5H21.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 13.5V16.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 16.5H18.5H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFolderAddRight;
